// Parses what people actually paste for coordinates.
// Accepts:  "41.7325, -49.9469"   "41.7325 N 49.9469 W"   "41°43'57\"N 49°56'48\"W"
// Returns { lat, lng } (numbers) or null.
export function parseCoords(input) {
  const s = String(input || "").trim();
  if (!s) return null;

  let lat, lng;

  if (/[°'"′″]/.test(s)) {
    // DMS: two groups, each ending in N/S/E/W
    const re = /(\d+(?:\.\d+)?)\s*[°:\s]\s*(\d+(?:\.\d+)?)?\s*['′]?\s*(?:(\d+(?:\.\d+)?)\s*["″]?)?\s*([NSEW])/gi;
    const m = [...s.matchAll(re)];
    if (m.length !== 2) return null;
    const conv = ([, d, mi, se, dir]) => {
      const v = parseFloat(d) + (mi ? parseFloat(mi) / 60 : 0) + (se ? parseFloat(se) / 3600 : 0);
      return /[SW]/i.test(dir) ? -v : v;
    };
    const a = conv(m[0]);
    const b = conv(m[1]);
    // first group is latitude if its hemisphere is N/S
    if (/[NS]/i.test(m[0][4])) { lat = a; lng = b; } else { lat = b; lng = a; }
  } else {
    // decimal, optional hemisphere letters
    const parts = s.replace(/[;,]/g, " ").split(/\s+/).filter(Boolean);
    const nums = [];
    const dirs = [];
    for (const p of parts) {
      const m = p.match(/^(-?\d+(?:\.\d+)?)([NSEW])?$/i) || p.match(/^([NSEW])?(-?\d+(?:\.\d+)?)$/i);
      if (m) {
        // second pattern puts the letter first
        const isLetterFirst = /^[NSEW]$/i.test(m[1] || "");
        nums.push(parseFloat(isLetterFirst ? m[2] : m[1]));
        dirs.push((isLetterFirst ? m[1] : m[2]) || "");
      } else if (/^[NSEW]$/i.test(p) && nums.length) {
        dirs[dirs.length - 1] = p;
      } else {
        return null;
      }
    }
    if (nums.length !== 2) return null;
    const signed = nums.map((n, i) => (/[SW]/i.test(dirs[i]) ? -Math.abs(n) : n));
    if (/[EW]/i.test(dirs[0]) || /[NS]/i.test(dirs[1])) { lng = signed[0]; lat = signed[1]; }
    else { lat = signed[0]; lng = signed[1]; }
  }

  if (![lat, lng].every(Number.isFinite)) return null;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  return { lat, lng };
}

export const formatCoords = (lat, lng) => `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
